import { useState } from "react"
import Select from 'react-select'
import Header from "../../../../../../Components/Header/Header"
import Sidebar from "../../../../../../Components/Sidebar/Sidebar"
import DeletePopup from "../../../GardenPopup/DeletePopup"
import moment from 'moment'
import { WardNameDataDDL } from "../../../../../../Components/CommonDDL/WardNameDataDDL"
import { useEffect } from "react"
import { useAuthState } from "../../../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { Pegination } from "../../../../../../Components/Pegination/Pegination"
import { DailyWorkSecurityDeleteAPI, DailyWorkSecurityTableDataAPI, DailyWorkSecurityTableExportDataAPI } from "../../../../../../Redux/SeverageDashboardSlice/SewerageDailyWorkMasterSlice/DailyWorkSecuritySlice"
import { Loading } from "../../../../../../Helper/Loading"
import ViewURL from "../../../../../../Components/ViewURL/ViewURL"
import { useSearchParams } from "react-router-dom"
import { PreventiveSecurityExportData } from "./PreventiveSecurityExportData"
import { TableNote } from "../../../../../../Components/Note/Note"
import { TableDeleteNote } from "../../../../../../Components/Note/TableDeleteNote"
import { toastErrorr } from "../../../../../../Helper/ToastMessage"


export default function PreventiveSecurityData() {
    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchNametitle = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [DeletePopupShow, setDeletePopupShow] = useState()

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? (moment(date).format('YYYY-MM') == moment().format('YYYY-MM') ? moment().format('YYYY-MM-DD') : moment(date).endOf('month').format('YYYY-MM-DD')) : moment().format('YYYY-MM-DD'))

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format("YYYY-MM-DD"))
    // const [ToDate, setToDate] = useState(moment().format("YYYY-MM-DD"))

    const [Heading, setHeading] = useState('')
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [PDF, setPDF] = useState('')
    const [PDFUrl, setPDFUrl] = useState('')

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)


    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [PumpingStation, setPumpingStation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        // setPumpingStation({
        //     ...PumpingStation,
        //     ID: 0,
        //     Label: 'Select...'
        // })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_SW_PumpingStationID: '0',
            Flag: 'Grid',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetPDFUrl: handleGetPDFUrl,
            handlePreventiveWorkSecurityExport: handlePreventiveWorkSecurityExport
        }
        dispatch(DailyWorkSecurityTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])

    const handlePreventiveWorkSecurityExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_SW_PumpingStationID: '0',
            Flag: 'Report',
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',

        }
        dispatch(DailyWorkSecurityTableExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.DailyWorkSecurityTableData)
    const { ExportTableData, isExportLoading } = useSelector(state => state.DailyWorkSecurityTableExportData)

    const handleGetPDFUrl = (pdfUrl) => {
        if (pdfUrl && pdfUrl != '') {
            setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }

    const handleDeleteApi = (item) => {
        const data = {
            T_SW_SecurityID: item.t_sW_SecurityID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(DailyWorkSecurityDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.DailyWorkSecurityDelete)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [IsPost, PumpingStation.ID, WardName.ID, FromDate, ToDate])

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName} />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <h5 className="ps-3 py-1">Preventive Work Security
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <PreventiveSecurityExportData
                                                ExcelData={ExportTableData}
                                                name='Preventive Work Security'
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                            // searchName={searchName}
                                            />
                                    }
                                    {
                                        tableData && tableData.table && tableData.table.length > 0 ?
                                            <button type="button"
                                                className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                onClick={handleOpenPdf}
                                            >PDF</button>
                                            :
                                            <></>
                                    }
                                </h5>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row rounded2">


                                                <div className="col-12 col-md-3 col-lg-3 ">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 ">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                            min={FromDate}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-3 col-lg-3 ">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />
                                                </div>
                                                {/* <div className="col-12 col-lg-3 " >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Pumping Station :</b></label>

                                                    <Select
                                                        // isClearable
                                                        // isRtl={isRtl}
                                                        isSearchable
                                                        maxMenuHeight={150}
                                                        value={{ value: PumpingStation.ID, label: PumpingStation.Label }}
                                                        onChange={(e) => {
                                                            e ?
                                                                setPumpingStation({ ...PumpingStation, ID: e.value, Label: e.label })
                                                                :
                                                                setPumpingStation({ ...PumpingStation, ID: 0, Label: "Select..." })

                                                        }}
                                                        options={PumpingStation.DDL}
                                                    />

                                                </div>
                                            </div> */}

                                                <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <TableDeleteNote />
                                            <div className="row mob_table table-responsive pt-2">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Pumping Station</th>
                                                            <th>Security Type</th>
                                                            <th>Work Date</th>
                                                            <th>Is Present</th>
                                                            <th>Photo</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                        <td>{item.pumpingStation ? item.pumpingStation : '-'}</td>
                                                                        <td>{item.securityTypeName ? item.securityTypeName : '-'}</td>
                                                                        <td className="date-col">{item.workDoneDate ? item.workDoneDate : '-'}</td>
                                                                        <td>{item.indicatorName ? item.indicatorName : '-'}</td>
                                                                        {/* <td class="ps-5">
                                                                            <span onClick={() => handleShowImage(item.photo, 'Photo')}>
                                                                                <i class="fa-solid fa-eye" title='View' style={{ cursor: 'pointer' }}

                                                                                ></i>
                                                                            </span>
                                                                        </td> */}
                                                                        <td style={{ textAlign: "center" }}>
                                                                            {
                                                                                (item.photo == null) ?
                                                                                    <span>-</span>
                                                                                    :
                                                                                    <>
                                                                                        <i className="fa-solid fa-eye" title='View'
                                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                            onClick={() => handleShowImage(item.photo, 'After Photo')}
                                                                                        ></i>
                                                                                    </>
                                                                            }
                                                                        </td>
                                                                        {

                                                                            ((item.workDoneDate) == moment().format('DD/MM/YYYY')) ?
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </td>
                                                                                :
                                                                                <td className="text-center">{'-'}</td>
                                                                        }

                                                                    </tr>
                                                                )
                                                            })
                                                                : <td colSpan={15}>No data found</td>
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    ShowImagePopup &&
                    <ViewURL
                        Heading={Heading}
                        ImagePopUpData={ImagePopUpData}
                        setshowImagePopup={setshowImagePopup}
                    />
                }
            </div>
        </>
    )
}